import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { IAction } from './actions/action';
import { ClearError } from './actions/clear-error';
import { SetButtons } from './actions/set-buttons';
import { SetError } from './actions/set-error';
import { SetHasFooter } from './actions/set-has-footer';
import { SetIcon } from './actions/set-icon';
import { SetIsDisabled } from './actions/set-is-disabled';
import { SetStatus } from './actions/set-status';
import { SetTitle } from './actions/set-title';
import { ModalButtonSet } from './contracts/modal-buttons';
import { ModalFormStatus } from './contracts/modal-form-status';
import { IState } from './contracts/state';

export class ModalFormHostManager {
    constructor() {
        this.onInit();
    }

    private static readonly DEFAULT_STATE: IState = {
        pending: false,
        name: '',
        title: '',
        icon: '',
        error: null,
        buttons: ModalButtonSet.OkCancel,
        status: ModalFormStatus.Iddle,
        isDisabled: false,
        hasFooter: true
    };

    private destroyed$ = new ReplaySubject<boolean>(1);
    private _state$ = new BehaviorSubject<IState>(ModalFormHostManager.DEFAULT_STATE);
    private get state(): IState { return this._state$.value; }
    private set state(value: IState) { this._state$.next(value); }

    state$ = this._state$.asObservable();

    onInit() {

    }

    dispatch(...actions: IAction[]) {
        actions.forEach(action => {
            if (action instanceof SetTitle) {
                this.setTitle(action);
            } else if (action instanceof SetIcon) {
                this.setIcon(action);
            } else if (action instanceof SetStatus) {
                this.setStatus(action);
            } else if (action instanceof ClearError) {
                this.clearError(action);
            } else if (action instanceof SetError) {
                this.setError(action);
            } else if (action instanceof SetButtons) {
                this.setButtons(action);
            } else if (action instanceof SetIsDisabled) {
                this.setIsDiabled(action);
            } else if (action instanceof SetHasFooter) {
                this.setHasFooter(action);
            }
        });
    }

    destroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    private setTitle(action: SetTitle) {
        this.state = {
            ...this.state,
            title: action.title
        };
    }

    private setIcon(action: SetIcon) {
        this.state = {
            ...this.state,
            icon: action.icon
        };
    }

    private setStatus(action: SetStatus) {
        this.state = {
            ...this.state,
            status: action.status
        };
    }

    private clearError(action: ClearError) {
        this.state = {
            ...this.state,
            error: null
        };

        this.dispatch(new SetStatus(ModalFormStatus.Iddle));
    }

    private setError(action: SetError) {
        this.state = {
            ...this.state,
            error: action.error
        };

        if (!!this.state.error) {
            this.dispatch(new SetStatus(ModalFormStatus.Error));
        }
    }

    private setButtons(action: SetButtons) {
        this.state = {
            ...this.state,
            buttons: action.buttons
        };
    }

    private setIsDiabled(action: SetIsDisabled) {
        this.state = {
            ...this.state,
            isDisabled: action.isDisabled
        };
    }

    private setHasFooter(action: SetHasFooter) {
        this.state = {
            ...this.state,
            hasFooter: action.hasFooter
        };
    }
}
